import { SharedConstants } from '@shared/Constants';
import { TDBFieldMappingItem } from '@shared/interfaces/TDBFieldMappingItem';

export const COMPETITORS_SALES_MAPPINGS: Map<string, TDBFieldMappingItem> = new Map([
  [
    'region_id',
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: 'region_id',
      name: 'region Id',
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: false,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    'name',
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: 'name',
      name: 'brick name',
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: true,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    'id',
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: 'id',
      name: 'brick Id',
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: false,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
  [
    'competitor',
    {
      columnWidth: SharedConstants.DEFAULT_COLUMN_WIDTH,
      fieldId: 'competitor',
      name: 'competitor name',
      isSortable: false,
      visibleInSummary: false,
      visibleInShortSummary: false,
      systemProp: false,
      isEditable: false,
      export: true
    }
  ],
]);
